// extracted by mini-css-extract-plugin
export default {"SocialNetworks":"SocialNetworks_SocialNetworks__ddV27"};